// store/store-init.js
import { createGlobalState } from "./GlobalStore"

const initialState = {
   sourceObject:null,
   destinationObject:null,
   onwardDate:null,
   returnDate:null,
   ServerBaseUrl:null,
   LocalwebUrl:null,
   journeyType:null,
   isReturnJourneyExist:false,
   onwardJourneyObject:null,
   returnJourneyObject:null,
   onwarJourneyData:null,
   onwardSelectedSeats:null,
   onwardBoardingPoint:null,
   onwardBoardingName:null,
   onwardDropingPoint:null,
   onwardDropingName:null,
   returnJourneyData:null,
   returnSelectedSeats:null,
   returnBoardingPoint:null,
   returnBoardingName:null,
   returnDropingPoint:null,
   returnDropingName:null,

};

export const useAppGlobalState = createGlobalState(initialState);

export const SetInitialDynamicData = (data) => {
  useAppGlobalState()[1]((prev) => ({ ...prev, ...data }));
};
